import Highway from '@dogstudio/highway/src/highway'
import lottie from 'lottie-web'

import animationTransition from '../../anims/transitions/tohome.jsonTransition'

class TransitionHome extends Highway.Transition {
    in({ from, to, done }) {
        const pageLoader = document.querySelector('.page__loader')
        pageLoader.innerHTML = ''

        const lottieTransition = lottie.loadAnimation({
            animationData: animationTransition,
            loop: false,
            autoplay: false,
            renderer: 'svg',
            container: pageLoader,
            rendererSettings: {
                preserveAspectRatio: 'none',
            },
        })
        // Reset Scroll
        window.scrollTo(0, 0)

        // Remove Old View
        from.remove()

        // lottieTransition.addEventListener('DOMLoaded', () => {
        lottieTransition.playSegments([8, 17], true)
        // })

        lottieTransition.addEventListener('complete', () => {
            done()
        })
    }

    out({ from, done }) {
        const pageLoader = document.querySelector('.page__loader')
        pageLoader.innerHTML = ''

        const lottieTransition = lottie.loadAnimation({
            animationData: animationTransition,
            loop: false,
            autoplay: false,
            renderer: 'svg',
            container: pageLoader,
            rendererSettings: {
                preserveAspectRatio: 'none',
            },
        })

        // lottieTransition.addEventListener('DOMLoaded', () => {
        lottieTransition.playSegments([0, 7], true)
        // })

        lottieTransition.addEventListener('complete', () => {
            done()
        })
    }
}

export default TransitionHome
